/** Shield-and-pulse mark from the HealthVox brand. The shield takes `currentColor`; the pulse is white. */
export function HealthVoxMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={className} fill="none" aria-hidden="true">
      <path
        d="M14.6 1.1Q16 0.6 17.4 1.1L28.4 4.9Q29.9 5.4 29.9 7V15.6C29.9 22.5 24 27.8 16 30.9C8 27.8 2.1 22.5 2.1 15.6V7Q2.1 5.4 3.6 4.9Z"
        fill="currentColor"
      />
      <path
        d="M6.9 15H11.6L14.7 8.5L17.1 20.4L20.2 12.3L21.6 15H25"
        stroke="#fff"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
